import {useEffect, useState} from "react";
import {RoleSchema} from "@feature/types";
import apiRequest from "@services/apiRequest";
import useAsyncError from "@hooks/useAsyncError";

export const useRoles = () => {

  // hooks
  const throwError = useAsyncError();

  // state
  const [data, setData] = useState<RoleSchema[]>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const result: RoleSchema[] = await apiRequest.get("/roles");
        setData(result);
      }
      catch (e) {
        throwError(e);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  return {data, loading};
}